import { useState } from 'react'

import { Anchor } from '@/components/ui/Anchor'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { Checkbox } from '@/components/ui/checkbox'
import { Checklist } from '@/routes/Public/marketing/components/Checklist'

export const VALUE_PROPS = [
  'Prevent fines',
  "Lower next year's insurance premiums",
  'Avoid a conditional rating',
  'Stay ready for audits, so violations never pile up',
]

export const LANDING_TITLE_LEAD = 'Secure document storage,'
const LANDING_TITLE_REST = 'with smart reminders to keep your fleet running'

export const LANDING_TITLE = `${LANDING_TITLE_LEAD} ${LANDING_TITLE_REST}`

export const LANDING_DISCLAIMER =
  'Compliance Vault is a product of Cai Labs, LLC. and does not impact any insurance products brokered through Cai Insurance Services.'

/** What a fleet sees before the vault is switched on: what it is for, and the way in. */
export function VaultLanding({ onStart }: { onStart: () => void }) {
  const [accepted, setAccepted] = useState(false)

  return (
    <Card>
      <CardHeader>
        <CardTitle className="max-w-2xl text-2xl leading-tight font-bold tracking-[-0.01em]">
          {LANDING_TITLE_LEAD}
          {/* Desktop only — at phone width the line already wraps on its own. */}
          <br className="max-sm:hidden" /> {LANDING_TITLE_REST}
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col items-start gap-6">
        <Checklist items={VALUE_PROPS} />
      </CardContent>
      <CardFooter className="flex flex-col items-start gap-4">
        <div className="flex items-center gap-2">
          <Checkbox
            id="vault-terms"
            checked={accepted}
            onCheckedChange={(checked) => setAccepted(checked === true)}
          />
          <label htmlFor="vault-terms" className="text-sm">
            I accept Compliance Vault{' '}
            <Anchor
              href="/terms"
              target="_blank"
              rel="noopener noreferrer"
              // Inside the label, a bare click would toggle the checkbox instead of opening the terms.
              onClick={(event) => event.stopPropagation()}
              className="hover:text-brand-800 underline underline-offset-2"
            >
              Terms and Conditions
            </Anchor>
            .
          </label>
        </div>
        <Button disabled={!accepted} onClick={onStart}>
          Import data from insurance application
        </Button>
        <p className="text-ink-500 max-w-2xl font-mono text-[10px] leading-relaxed">{LANDING_DISCLAIMER}</p>
      </CardFooter>
    </Card>
  )
}
